/**
 * Enum representing different coin types used in the survey card.
 */
export enum SurveyCardCoins {
  CoinBig = 'coin-big',
}
